export const styles = {
  root: {
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '4px',
    transition: '.3s all ease',
    color: '#787878',
    '&:hover': {
      backgroundColor: '#fff',
    },
    primary: {
      '&:hover': {
        color: '#009FDA',
      },
    },
    error: {
      '&:hover': {
        color: '#FF4D4F',
      },
    },
  },
  in: {
    width: '24px',
    height: '24px',
    color: 'inherit',

    '& > svg': {
      width: '100%',
      height: '100%',
    },
  },
}
